import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChair = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "24px",
	height: "24px",
	viewBox: "0 0 45 45",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		transform: "translate(5 5) scale(0.78)",
		style: {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "3.6px"
		},
		children: [/* @__PURE__ */ _jsx("rect", {
			x: 2,
			y: 2,
			width: 41,
			height: 35,
			rx: 4
		}), /* @__PURE__ */ _jsx("rect", {
			x: 4,
			y: 37,
			width: 37,
			height: 6,
			rx: 3
		})]
	})
});
export default SvgChair;
